  jQuery(function($){
    var $prevButton = $('.featured-promotions__nav--prev');
    var $nextButton = $('.featured-promotions__nav--next');
    
    var carousel_collection_list= $('.collection-list-slider');
    
    $(carousel_collection_list).flickity({
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false, // advance cells every 3 seconds
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_collection_list).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_collection_list).flickity('next');
        });
        }
      }
    });

    var carousel_blogs = $('.blog-inner-container');
    
    $(carousel_blogs).flickity({
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false, // advance cells every 3 seconds
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_blogs).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_blogs).flickity('next');
        });
        }
      }
    });

   var carousel_subcollections = $('.list-collection-wrapper');
    
    $(carousel_subcollections).flickity({
      freeScroll: true,
      imagesLoaded: true,
      contain: true,
      wrapAround: true,
      draggable: true,
      cellAlign: 'left',
      watchCSS: true,
      initialIndex: 0,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false, // advance cells every 3 seconds
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_subcollections).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_subcollections).flickity('next');
        });
        }
      }
    });

    
    var carousel_product_promotions_loop_slider_colection = $('.product-loop-slider-promotions');
    var $prevButton = $('.featured-promotions__nav--prev_collection');
    var $nextButton = $('.featured-promotions__nav--next_collection');
     $(carousel_product_promotions_loop_slider_colection).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_promotions_loop_slider_colection).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_promotions_loop_slider_colection).flickity('next');
        });
        }
      }
        
    });

     var carousel_product_promotions_loop_slider = $('.complete-the-look-slider');
    var $prevButton = $('.complete_the_look__nav--prev');
    var $nextButton = $('.complete_the_look__nav--next');
     $(carousel_product_promotions_loop_slider).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_promotions_loop_slider).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_promotions_loop_slider).flickity('next');
        });
        }
      }
        
    });

     var carousel_product_loop_slider = $('.product-loop-slider');
     $(carousel_product_loop_slider).flickity({
        // options
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: false,// advance cells every 3 seconds
        on: {
        ready: function() {
          // Resize flickity when the slider is settled
          
          $prevButton.on('click', function () {
            $(carousel_product_loop_slider).flickity('previous');
          });

          $nextButton.on('click', function () {
            $(carousel_product_loop_slider).flickity('next');
        });
        }
      }
        
    });

    $('#ptw-gift-needed').click(function() {
        $("#txtAge").toggle(this.checked);
    });

    
  });

/* Icon bar */

/* Icon bar */
var elem = document.querySelector('.icon-bars');
var flkty = new Flickity( elem, {
  wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  fade: true,
  watchCSS: true,
  prevNextButtons: false,
  accessibility: true, //true by default
  autoPlay: true // advance cells every 3 seconds
});

/* Scroll to Top */
function scrollTop() {
  // 500 -> This is the value in px of the distance to be scrolled for the 'scroll-to-top' button to show-up
  if ($(window).scrollTop() > 500) {
    $(".backToTopBtn").addClass("active");
  } else {
    $(".backToTopBtn").removeClass("active");
  }
}
$(function () {
  // show and hide btn
  scrollTop();
  $(window).on("scroll", scrollTop);

  // body scroll on btn click
  $(".backToTopBtn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1);
    return false;
  });
});

$('.sub-collections_slider').flickity({
        // options
  freeScroll: true,
  imagesLoaded: true,
  draggable: true,
  cellAlign: 'center',
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
  autoPlay: true
});

$('.sub_collection_mobile').flickity({
        // options
  freeScroll: true,
  imagesLoaded: true,
  draggable: true,
  cellAlign: 'center',
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
  autoPlay: true
});
